import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=89ca7440&"
import script from "./Contact.vue?vue&type=script&lang=ts&"
export * from "./Contact.vue?vue&type=script&lang=ts&"
import style0 from "./Contact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnimateHeading: require('/Users/markussh/git/theodora-tech-website/src/components/animate/AnimateHeading.vue').default,ContactList: require('/Users/markussh/git/theodora-tech-website/src/components/ContactList/ContactList.vue').default,AnimateFade: require('/Users/markussh/git/theodora-tech-website/src/components/animate/AnimateFade.vue').default})
